import {Dispatch, SetStateAction} from "react";
import {IImageAttributeTypes, ImageUpload} from "./ImageUpload";
import {runInAction} from "mobx";
import ClickableLink from "../../../components/utilities/ClickableLink";
import {observer} from "mobx-react";
import styles from "./styles/Branding.module.scss";
import {useStores} from "../../../stores/useStores";
import {withLocaleInURI} from "../../../internationalization/i18nURI";
import FontAwesome from "../../../components/utilities/FontAwesome";
import {useFeatureFlags} from "../../../utils/featureFlags/useFeatureFlags";
import {ContactTypeSelection} from "../../../components/modals/PeopleCollectionManagementModal/ContactTypeSelection";

export const Branding = observer((props: {
    hideHeaderTitle: boolean,
    setHideHeaderTitle: SetStateAction<any>,
    hideHeaderLoginButton: boolean,
    setHideHeaderLoginButton: SetStateAction<any>,
    staffDirectoryContactType: string | null,
    setStaffDirectoryContactType: Dispatch<SetStateAction<string | null>>,
    showSchoolFeedWidget: string,
    setShowSchoolFeedWidget: SetStateAction<any>,
    inheritSchoolFeedWidget: boolean,
    setInheritSchoolFeedWidget: SetStateAction<any>,
}) => {
    const {organizationStore, i18nStore} = useStores();
    const {show_email_setting_alert} = useFeatureFlags();

    return <div className="panel panel-default">
        <div className="panel-heading">
            <h3 className="panel-title text-center">Branding</h3>
        </div>
        <div className="panel-body">
            {["top_nav_logo", "picture", "favicon"].map((imageType: IImageAttributeTypes) => {
                let label: string = "";
                switch (imageType) {
                    case "top_nav_logo":
                        label = "Top Navigation Logo";
                        break;
                    case "picture":
                        label = "Picture";
                        break;
                    case "favicon":
                        label = "Browser Favicon";
                        break;
                }

                const imageUrl = (organizationStore.organization.id === organizationStore.currentOrganization.id) ?
                    organizationStore.organization[imageType] : organizationStore.currentOrganization[imageType];

                function handleImageChange(value) {
                    runInAction(() => {
                        if (organizationStore.organization.id === organizationStore.currentOrganization.id) {
                            organizationStore.organization[imageType] = value;
                        } else {
                            organizationStore.currentOrganization[imageType] = value;
                        }
                    })
                }

                return <div className={styles.imageUploadContainer}>
                    <ImageUpload
                        imageType={imageType}
                        key={imageType}
                        label={label}
                        handleImageUrlChange={handleImageChange}
                        imageUrl={imageUrl}
                    />
                </div>
            })}
            <div className="row">
                <div className="col-lg-12">
                    <input title="Toggle title text visibility from header" type="checkbox"
                           className="checkbox-default-links"
                           checked={props.hideHeaderTitle} onChange={() => props.setHideHeaderTitle(v => !v)}/>
                    &nbsp;<label>Hide title text from header</label>
                    &nbsp;(useful if the logo contains the same title as the text)
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12">
                    <input title="Toggle login button visibility in header" type="checkbox"
                           className="checkbox-default-links"
                           checked={props.hideHeaderLoginButton}
                           onChange={() => props.setHideHeaderLoginButton(v => !v)}/>
                    &nbsp;<label>Hide login button from header</label>
                    &nbsp;(login functionality is still available from a link in the footer)
                </div>
            </div>

            <div className="row">
                <div className="col-lg-12">
                    {show_email_setting_alert ? (
                        <div style={{
                            padding: '15px',
                            backgroundColor: '#d1ecf1',
                            border: '1px solid #bee5eb',
                            borderRadius: '4px',
                            marginBottom: '10px',
                        }}>
                            <strong>Setting Moved:</strong> The &quot;Display Email Addresses on Staff Listing
                            Pages&quot; setting has been moved to the{' '}
                            <ClickableLink href={withLocaleInURI(`/staff`, i18nStore.currentOrgSupportedLocale)}>
                                <FontAwesome className={'fas'} name={'fa-gear'}/> Manage Members menu on the staff
                                collection page
                            </ClickableLink>
                            .
                        </div>
                    ) : (
                        <ContactTypeSelection />
                    )}
                </div>
            </div>
            <div className="row">
                <div className="col-lg-3">
                    <label>Display SchoolFeed Widget <ClickableLink
                        href={"https://docs.google.com/document/d/1HxPCOMfjFs-wbWw5bLDMozjUqoCIZfd6hlbSJouTX5w/edit?usp=sharing"}>Learn
                        More</ClickableLink></label>
                </div>
                <div className="col-lg-4">
                    <select value={props.showSchoolFeedWidget}
                            onChange={e => props.setShowSchoolFeedWidget(e.target.value)} className={'form-control'}
                            title={'Toggle Displaying SchoolFeed Widget on Main Pages'}>
                        <option value={"off"}>Off</option>
                        <option value={"admins"}>Enable for Admins Only</option>
                        <option value={"everyone"}>Enable for Everyone</option>
                    </select>
                </div>
            </div>
            {organizationStore.organization.type === "district" && <div className="row">
                <div className="col-lg-12">
                    <input title="Inherit SchoolFeed Widget setting on school pages" type="checkbox"
                           className="checkbox-default-links"
                           checked={props.inheritSchoolFeedWidget}
                           onChange={() => props.setInheritSchoolFeedWidget(v => !v)}
                    />
                    &nbsp;<label>Inherit SchoolFeed Widget setting on school pages</label>
                    <small style={{display: "block"}}>If disabled, SchoolFeed will not appear on school sites unless
                        manually enabled in the school's configuration.</small>
                </div>
            </div>}
        </div>
    </div>
})
